import {useEffect, useState} from "react";
import {BreadCrumbs} from "../../../components/open/pages";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ThinCreditScoreIcon, ThinTrashIcon, TomansIcon} from "../../../components/icons/material-icons";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {RemoveModal} from "../../../components/template/remove-modal";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import {AdminsStaffCreateSalaryModal} from "./create-salary-payment";

interface salaryInterface {
    id: number,
    title: string,
    createdAt: string,
    count: number,
    total:number,
}

interface salaryPaidInterface{
    id:number,
    itemId:number,
    title:string,
    createdAt:string,
    price:number,
}

export const AdminsStaffSalariesScreen = () => {
    const [list, setList] = useState<salaryInterface[]>([]);
    const [loaded, setLoaded] = useState(false);
    const fetchList = () => {
        PostJSON(
            Apis.server + '/core/admins/staff/salary/list',
            {},
            true,
            (d: {
                result: string,
                reason: string,
                list: salaryInterface[] | null
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setList(d.list === null ? [] : d.list);
                setLoaded(true);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "حقوق | منابع انسانی | اتوماسیون";
        fetchList();
    }, []);
    const [removeModal, setRemoveModal] = useState({
        show: false,
        title: '',
        id: 0,
    });
    const [createModal, setCreateModal] = useState(false);
    return (
        <>
            <BreadCrumbs links={[
                {url: '/admins', title: 'اتوماسیون'},
                {url: '/admins/staff', title: 'منابع انسانی'},
                {url: '/admins/staff/salaries', title: 'حقوق'},
            ]}/>
            {
                loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>واریزهای حقوق</b>
                                <button onClick={() => setCreateModal(true)}>
                                    <ThinCreditScoreIcon/>
                                    <span>ایجاد واریزی</span>
                                </button>
                            </div>
                            <table className="table open-table table-striped table-hover table-bordered">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>عنوان</th>
                                    <th>تاریخ</th>
                                    <th>تعداد افراد</th>
                                    <th>مبلغ کل</th>
                                    <th>امکانات</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    list.map((s, i) =>
                                        <tr key={"Hru238DD9sSalary2SDD_" + i}>
                                            <td>{CurrencyFormat(i + 1)}</td>
                                            <td>{s.title}</td>
                                            <td>
                                                {StringDigitsConvertToPersian(s.createdAt.split(' ')[1] + " " + GregorianToPersian(s.createdAt.split(' ')[0]).replaceAll('-', '/'))}
                                            </td>
                                            <td>{CurrencyFormat(s.count)} نفر</td>
                                            <td>
                                                <span>{CurrencyFormat(s.total)}<TomansIcon/></span>
                                            </td>
                                            <td>
                                                <div className="d-inline-flex align-items-center" style={{gap: 5}}>
                                                    <button className="open-tooltip" onClick={() => setRemoveModal({
                                                        title: s.title,
                                                        show: true,
                                                        id: s.id,
                                                    })}>
                                                        <i>حذف</i>
                                                        <ThinTrashIcon/>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div> : null
            }
            <RemoveModal
                active={removeModal.show}
                closeHandler={() => setRemoveModal(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                title={"حذف واریزی"}
                desc={`آیا مطمئن هستید می‌خواهید ${removeModal.title} را حذف کنید؟`}
                onRemove={() => {
                    ShowProgressLoading();
                    const x = {...removeModal};
                    ShowProgressLoading();
                    PostJSON(
                        Apis.server + '/core/admins/staff/salary/remove',
                        {
                            id: x.id,
                        },
                        true,
                        (d: {
                            result: string,
                            reason: string | undefined,
                        }) => {
                            HideProgressLoading();
                            if (d.result !== 'OK') {
                                if (d.reason === 'login')
                                    AuthRedirectAdmins();
                                return;
                            }
                            ShowSnackbar(
                                'واریزی حذف گردید.',
                                'باشه',
                                5000,
                            );
                            ShowProgressLoading();
                            fetchList();
                        },
                        () => {
                        },
                        AuthRedirectAdmins,
                    ).then(void 0);
                }}
            />
            <AdminsStaffCreateSalaryModal
                active={createModal}
                closeHandler={() => setCreateModal(false)}
                onDone={() => {
                    ShowProgressLoading();
                    fetchList();
                }}
            />
        </>
    );
};